/* eslint-disable array-callback-return */
import Services from "../../utils/services";
import { Component } from "react";

class SuggestionsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            suggestions: [],
            fieldedSuggestions: [],
            keyEventName: '',
            cursor: -1
        }
    }
    componentDidMount() {
        //console.log(this.props.searchKeyword);
        this.getSuggestionsList(this.props.searchKeyword)
        this.setState({
            keyEventName: ''
        })
    }
    getSuggestionsList = async (keyword) => {
        let services = new Services();
        if (this.props.searchKeyword.length > 0) {
            let res = await services.getSuggestions(keyword)
            if (res.data) {
                this.setState({
                    suggestions: res.data.dictionarySuggestions,
                    fieldedSuggestions: res.data.fieldSuggestions
                })
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        //console.log(nextProps.keyEventName)
        if (nextProps.searchKeyword !== this.props.searchKeyword) {
            this.getSuggestionsList(nextProps.searchKeyword)
        }
        if (this.props.keyEventName) {
            if (this.props.keyEventName.includes('ArrowDown')) {
                this.setState({
                    keyEventName: this.props.keyEventName
                }, () => {
                    this.handleKeyDown(this.state.keyEventName)
                })
            }
        }
    }
    componentWillUnmount() {
        this.setState({
            suggestions: [],
            fieldedSuggestions: [],
            keyEventName: '',
            cursor: 0
        })
    }
    listOfSuggestions = (arr) => {
        //console.log(arr);
        if (arr.length > 0) {
            return (
                arr.map((item, index) => {
                    if (item) {
                        return (
                            <li key={index} onClick={e => this.setSearchKeyword(item)} className={this.state.cursor === index ? 'suggestions-list-active' : ''} onMouseEnter={e => this.handleOnEnter}>{this.convertToHtml(item)}</li>
                        )
                    }
                })
            )
        }
    }
    convertToHtml = (item) => {
        return (<div dangerouslySetInnerHTML={{ __html: item }}></div>)
    }
    setSearchKeyword = (item) => {
        let fieldedValue, query;
        //console.log(item)
        let keyword = item.replaceAll('<b>', '').replaceAll('</b>', '');
        if (keyword.lastIndexOf(' in all ') > 0) {
            //console.log(keyword)
            let indexofField = keyword.lastIndexOf('in all');
            fieldedValue = keyword.substring(indexofField + 7, keyword.length);
            query = keyword.substring(0, indexofField - 1);
            /* fieldedValue = keyword.split(' in all ')[1]
            query = keyword.split(' in all ')[0] */
            this.props.handleOnChange(query, fieldedValue)
            this.props.handleOnSuggestionClick(true);
        }
        else {
            query = keyword
            this.props.handleOnChange(query, null);
        }
        //console.log(item.replace('<b>','').replace('</b>',''));
    }
    handleOnEnter = (e) => {
        if (['Enter'].includes(e.key)) {
            //console.log(e.target.value)
        }
    }
    handleKeyDown = (e) => {
        //console.log(e)
        const { cursor, suggestions } = this.state
        if (e === 'ArrowUp' && cursor > 0) {
            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }), () => {
                this.setSearchKeyword(suggestions[this.state.cursor])
            })
        } else if (e === 'ArrowDown' && cursor < suggestions.length - 1) {
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }), () => {
                this.setSearchKeyword(suggestions[this.state.cursor])
            })
        }
        //console.log(e);
    }
    render() {
        return (
            <>
                {this.props.showSuggestions &&
                    <div className="suggestions-list-wrapper">
                        {this.state.suggestions.length > 0 || this.state.fieldedSuggestions.length > 0 ?
                            <ul>
                                {this.listOfSuggestions(this.state.suggestions)}
                                {this.state.suggestions.length > 0 && this.state.fieldedSuggestions.length > 0
                                    // &&
                                    // <hr/>
                                }
                                {this.state.fieldedSuggestions.length > 0 &&
                                    <>
                                        <div className="suggestions-fielded-header">Are you looking for..</div>
                                        {this.listOfSuggestions(this.state.fieldedSuggestions)}
                                    </>
                                }
                            </ul>
                            :
                            <></>
                        }
                    </div>
                }
            </>
        )
    }
}
export default SuggestionsList;